const e = {
  name: "Number7Circle",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<path class="st0" d="M16,16h6v10h2V14h-8V16z"/>
<path class="st0" d="M20,0c11,0,20,9,20,20s-9,20-20,20S0,31,0,20S9,0,20,0z M2,20c0,9.9,8.1,18,18,18s18-8.1,18-18S29.9,2,20,2
	S2,10.1,2,20z"/>
</svg>
  `
};
export {
  e as Number7Circle
};
